import styled from 'styled-components'

export const GiftsWrapper = styled.section`
	background-color: #f0eaf3;
	padding: 80px 15px 40px;
	position: relative;

	&::before {
		content: '';
		position: absolute;
		right: 0;
		left: -0%;
		top: -30px;
		z-index: 10;
		display: block;
		height: 30px;
		background-size: 30px 100%;
		background-image: linear-gradient(135deg, #f0eaf3 25%, transparent 25%),
			linear-gradient(225deg, #f0eaf3 25%, transparent 25%);
		background-position: 0 0;
		transform: rotate(180deg);
	}
`

export const SectionContent = styled.article`
	max-width: 800px;
	margin: 0 auto;
`

export const ETransferContainer = styled.div`
	margin: 10px 0;
`

export const ETransferIcon = styled.img`
	max-width: 30px;
	margin-right: 10px;
`

export const PixCode = styled.img`
	display: block;
	margin: 10px auto 0;
	max-width: 200px;
`
